import { useAppSelector } from "@/store/app/hooks";
import type { RootState } from "@/store/app/storeTypes";
import { selectActiveSparxEditorOriginalData } from "./useActiveData";

export const useOriginalData =
  (): RootState["editor"]["sparx"]["originalData"] => {
    return useAppSelector(selectActiveSparxEditorOriginalData);
  };
